
import { BRAND_COLLECTIONS, collectionPath } from "@/utils/collections";
// Proper casing for the accessible names on the social links — the config keys
// are lowercase ("youtube", "linkedin") and would otherwise be announced as-is.
const SOCIAL_LABELS = {
  instagram: "Instagram",
  facebook: "Facebook",
  youtube: "YouTube",
  linkedin: "LinkedIn"
}

export default {
  data() {
    return { BRAND_COLLECTIONS };
  },

  methods: {
    collectionPath,

    socialLabel(social) {
      return SOCIAL_LABELS[social] || social
    }
  }
}
